/**
 * Chart.js registration for Bid Analysis templates.
 * Import once in each template core hook (useNCTemplateCore, useMASDirectTemplateCore, useMASIndirectTemplateCore).
 */
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  LineElement,
  LineController,
  PointElement,
  Title,
  Tooltip,
  Legend
);
